<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="!isEdit?$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.addfaultcode'):$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.editfaultcode')"
      :icon="!isEdit?'icon-dialog-add': 'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="formLeft"
        :rules="rulesCenter"
        :model="formInfo"
        :label-position="'right'"
        :label-width="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.labelWidth.formLeft')"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.faultcode')+'：'" prop="faultCode">
              <el-input v-model="formInfo.faultCode" :disabled="isEdit ? true: false" clearable :placeholder="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.faultcode')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.brand')+'：'" prop="faultLevel">
              <el-select v-model="formInfo.brandId" filterable clearable :placeholder="$t('diagnostics.faultcodemanage.faultcode.brand')" @change="selectGet">
                <el-option v-for="(item,index) in brandList" :key="index" :label="item.test" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.faultname')+'：'" prop="faultName">
              <el-input v-model="formInfo.faultName" clearable :placeholder="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.faultname')" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.detailFaulcode')+'：'" prop="faultContent">
              <el-input
                v-model="formInfo.faultContent"
                :rows="6"
                :autosize="{ minRows: 3, maxRows: 3}"
                resize="none"
                type="textarea"
                clearable
                maxlength="2000"
                show-word-limit
                :placeholder="$t('diagnostics.faultcodemanage.faultcode.detailFaulcode')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('public.note')+'：'" prop="remark">
              <el-input
                v-model="formInfo.remark"
                :rows="6"
                :autosize="{ minRows: 3, maxRows: 3}"
                resize="none"
                type="textarea"
                maxlength="500"
                show-word-limit
                :placeholder="$t('public.note')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.ispopfault')+'：'" :label-width="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.labelWidth.formLeft')">
              <el-radio-group v-model="formInfo.isPush">
                <el-radio :label="0">
                  {{ vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.no') }}
                </el-radio>
                <el-radio :label="1">
                  {{ vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.yes') }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{ $t('public.define') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { createFaultCode, updateFaultCode, getBrand } from '@/api/fault/faultCode'

export default {
  name: 'AddUpdateDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // faultcode
    const validatefaultcode = (rule, value, cb) => {
      if (value === '' || value === undefined) {
        return cb(new Error(vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.message1')))
      }
      if (value.length > 10) {
        return cb(new Error(this.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.lengthMessage') + ' 10'))
      }
    }

    const validatefaultname = (rule, value, cb) => {
      if (value === '' || value === undefined) {
        return cb(new Error(vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.message4')))
      }
      if (value.length > 500) {
        return cb(new Error(this.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.lengthMessage') + ' 500'))
      }
    }
    const validatefaultContent = (rule, value, cb) => {
      if (value && value.length > 2000) {
        return cb(new Error(this.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.lengthMessage') + ' 2000'))
      }
    }
    
    const validatefaultRemark = (rule, value, cb) => {
      if (value && value.length > 500) {
        return cb(new Error(this.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.lengthMessage') + ' 500'))
      }
    }
    const vm = window.vm
    return {
      vm: vm,
      formInfo: {},
      faultLevelList: [
        { label: vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.level1'), value: 1 },
        { label: vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.level2'), value: 2 },
        { label: vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.level3'), value: 3 },
        { label: vm.$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.level4'), value: 4 }
      ],
      carPartList: [],
      brandList: [],
      specificBrand: '',
      rulesCenter: {
        faultCode: [
          { required: true, trigger: 'blur', validator: validatefaultcode },
          { trigger: 'change', validator: validatefaultcode }
        ],
        faultName: [
          { required: true, trigger: 'blur', validator: validatefaultname },
          { trigger: 'change', validator: validatefaultname }
        ],
        faultContent: [
          { trigger: 'change', validator: validatefaultContent }
        ],
        remark: [
          { trigger: 'change', validator: validatefaultRemark }
        ],
      }
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.getBrandList()
        this.formInfo = { ...{ isPush: 1 }, ...this.data }
        if (this.isEdit) {
          this.specificBrand = this.data.specificBrand
        }
      }
    }
  },
  created() {
  },
  methods: {

    // 关闭
    closeDialog() {
      this.specificBrand = ''
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    // 车辆品牌
    getBrandList() {
      getBrand().then(({ data }) => {
        if (data.code === 0) {
          this.brandList = data.data || []
        }
      })
    },
    selectGet(vId) {
      let obj = {}
      obj = this.brandList.find((item) => {
        return item.value === vId // 筛选出匹配数据
      })
      this.specificBrand = obj.test
    },
    // 提交
    handleSubmit() {
      const formCheckLeft = this.checkForm({
        formName: 'formLeft',
        formList: ['faultCode', 'specific', 'faultName', 'faultContent']
      })
      if (!formCheckLeft) {
        return
      }
      const { faultCodeId, ...postData } = this.formInfo
      for (const k in postData) {
        if (postData[k] === undefined) {
          postData[k] = ''
        }
      }
      postData.specificBrand = this.specificBrand
      if (!this.isEdit) {
        this._createFaultCode(postData)
      } else {
        postData.faultCodeId = faultCodeId
        this._updateFaultCode(postData)
      }
    },
    // 新增
    _createFaultCode(postData) {
      createFaultCode(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    _updateFaultCode(postData) {
      updateFaultCode(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
